import { SET_STORE } from "@/store/constants/store";

export default {
    [SET_STORE]: (state, store) => state.store = store
}